var _path, _path2, _rect, _br, _text, _path3, _path4, _text2, _path5, _b, _text3, _path6, _path7, _rect2, _text4, _path8, _br2, _b2, _br3, _br4, _br5, _br6, _text5, _path9, _path10, _rect3, _rect4, _br7, _br8, _br9, _text6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _text7, _rect5, _rect6, _text8, _path19, _path20, _path21, _path22, _image, _path23, _path24, _path25, _path26, _text9, _path27, _path28, _rect7, _br10, _b3, _b4, _text10, _path29, _path30, _path31, _path32, _image2, _br11, _text11, _rect8, _rect9, _br12, _u, _u2, _text12, _rect10, _rect11, _br13, _u3, _text13, _path33, _b5, _br14, _text14, _path34, _path35, _path36, _path37, _rect12, _b6, _br15, _b7, _text15, _path38, _path39, _path40, _path41, _rect13, _rect14, _br16, _text16, _image3, _b8, _br17, _br18, _text17, _rect15, _br19, _b9, _b10, _text18, _path42, _path43, _image4, _b11, _text19, _path44, _rect16, _rect17, _text20, _rect18, _rect19, _text21, _rect20, _rect21, _text22, _rect22, _rect23, _text23, _path45, _path46, _path47, _path48, _rect24, _rect25, _path49, _path50, _rect26, _rect27, _br20, _br21, _text24, _path51, _path52, _text25, _rect28, _rect29, _br22, _text26, _rect30, _rect31, _br23, _text27, _rect32, _rect33, _br24, _text28, _rect34, _rect35, _text29, _rect36, _rect37, _br25, _text30, _rect38, _rect39, _text31, _rect40, _rect41, _text32, _rect42, _rect43, _text33, _rect44, _rect45, _text34, _rect46, _rect47, _text35, _rect48, _rect49, _text36, _switch;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCiCdFlowchart = function SvgCiCdFlowchart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "740px",
    height: "821px",
    viewBox: "-0.5 -0.5 740 821",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "mx-gradient-ffffff-1-ebebeb-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255, 255, 255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(235, 235, 235)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%",
    id: "mx-gradient-ffffff-1-ff9933-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255, 255, 255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255, 153, 51)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 153.48 272 L 153.48 292.04 L 153.52 292.91",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 153.98 301.9 L 149.03 293.14 L 158.02 292.68 Z",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://code.visualstudio.com/",
    target: "_blank"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 223,
    width: 303,
    height: 49,
    rx: 7.35,
    ry: 7.35,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 301,
      height: 1,
      paddingTop: 248,
      marginLeft: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Use a local Windows 10 development computer", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "\xA0 to make code changes\xA0using VS CODE")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 251,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Use a local Windows 10 development computer..."))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 304 349 L 348.88 349",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 357.88 349 L 348.88 353.5 L 348.88 344.5 Z",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 339,
      marginLeft: 331
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Yes")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 331,
    y: 342,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Yes")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 154 303 L 304 349 L 154 395 L 4 349 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 290,
      height: 1,
      paddingTop: 347,
      marginLeft: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Did you make ", _b || (_b = /*#__PURE__*/React.createElement("b", null, "code ", /*#__PURE__*/React.createElement("br", null), "changes")), " on your PC?")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 351,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Did you make code...")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 569 349 L 606.63 349",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 611.88 349 L 604.88 352.5 L 606.63 349 L 604.88 345.5 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.github.com/en/pull-requests/collaborating-with-pull-requests/proposing-changes-to-your-work-with-pull-requests/about-pull-requests",
    target: "_blank"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 310,
    width: 210,
    height: 78,
    rx: 11.7,
    ry: 11.7,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 349,
      marginLeft: 360
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Add and commit code locally, using git commands\xA0and then push to github,\xA0and use Pull Requests if needed, merge to main branch")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 464,
    y: 353,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Add and commit code locally, using..."))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/repos/github?view=azure-devops&tabs=yaml",
    target: "_blank"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 425 L 305 480 L 155 535 L 5 480 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 290,
      height: 1,
      paddingTop: 478,
      marginLeft: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null)), _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, "Run Azure Pipeline?")), _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null)), "because code change(s)", _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null)), "were detected", _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null)), "in Github by", _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null)), "Azure Devops")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 482,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Run Azure Pipeline?..."))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 304.05 154.17 L 304.04 195 L 154.04 195 L 154.04 216.63",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 154.04 221.88 L 150.54 214.88 L 154.04 216.63 L 157.54 214.88 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 35,
    width: 730,
    height: 120,
    rx: 18,
    ry: 18,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 35,
    width: 730,
    height: 120,
    rx: 18,
    ry: 18,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 95,
      marginLeft: 367
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "CI/CD: ", _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null)), "Using Azure Devops, Github, Repositories, ", _br8 || (_br8 = /*#__PURE__*/React.createElement("br", null)), "Pipelines and Deployment Targets to publish ", _br9 || (_br9 = /*#__PURE__*/React.createElement("br", null)), "compiled code\xA0to an In-House Server (behind a firewall)\xA0\xA0")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 367,
    y: 102,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "24px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "CI/CD:...")))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://www.github.com/scottdevopsgithub",
    target: "_blank"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 658 299 L 703 320.61 L 703 377.39 L 658 399 L 613 377.39 L 613 320.61 Z",
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 658 299 L 703 320.61 L 703 377.39 L 658 399 L 613 377.39 L 613 320.61 Z",
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 613 320.61 L 658 342.21 L 703 320.61 M 658 342.21 L 658 399",
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 656.14 299.81 L 703.49 322.27 L 701.6 376.55 L 658.64 398.61 L 612.27 376.61 L 613.4 320.84 L 656.07 300.12",
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 656.14 299.81 L 703.49 322.27 L 701.6 376.55 L 658.64 398.61 L 612.27 376.61 L 613.4 320.84 L 656.07 300.12",
    fill: "url(#mx-gradient-ffffff-1-ebebeb-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 658 299 M 658 299 C 670.73 304.15 683.24 310.36 703 320.61 M 658 299 C 671.59 306.83 686.74 312.66 703 320.61 M 703 320.61 C 704.33 333.23 702.86 346.33 703 377.39 M 703 320.61 C 703.82 341.7 703.77 362.49 703 377.39 M 703 377.39 C 689.22 385.47 670.87 393.76 658 399 M 703 377.39 C 693.31 380.69 683.95 386.47 658 399 M 658 399 C 649.91 393.17 638.68 390.6 613 377.39 M 658 399 C 642.43 390.44 624.44 383.48 613 377.39 M 613 377.39 C 612.8 361.51 613.04 346.58 613 320.61 M 613 377.39 C 612.42 362.79 612.49 348.07 613 320.61 M 613 320.61 C 625.62 315.87 636.45 308.99 658 299 M 613 320.61 C 625.37 314.44 635.5 309.41 658 299",
    fill: "none",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 658 299 M 658 299 C 670.73 304.15 683.24 310.36 703 320.61 M 658 299 C 671.59 306.83 686.74 312.66 703 320.61 M 703 320.61 C 704.33 333.23 702.86 346.33 703 377.39 M 703 320.61 C 703.82 341.7 703.77 362.49 703 377.39 M 703 377.39 C 689.22 385.47 670.87 393.76 658 399 M 703 377.39 C 693.31 380.69 683.95 386.47 658 399 M 658 399 C 649.91 393.17 638.68 390.6 613 377.39 M 658 399 C 642.43 390.44 624.44 383.48 613 377.39 M 613 377.39 C 612.8 361.51 613.04 346.58 613 320.61 M 613 377.39 C 612.42 362.79 612.49 348.07 613 320.61 M 613 320.61 C 625.62 315.87 636.45 308.99 658 299 M 613 320.61 C 625.37 314.44 635.5 309.41 658 299",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 613 320.61 M 613 320.61 C 624.07 323.57 630.89 330.09 658 342.21 M 613 320.61 C 625.74 326.96 637.21 333.47 658 342.21 M 658 342.21 C 670.55 336.08 683.06 331 703 320.61 M 658 342.21 C 671.83 336.11 686.98 328.01 703 320.61 M 658 342.21 M 658 342.21 C 659.33 354.83 657.86 367.93 658 399 M 658 342.21 C 658.82 363.3 658.77 384.1 658 399",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 349,
      marginLeft: 614
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Github\xA0 \xA0 Repo")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 658,
    y: 353,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Github\xA0 \xA0 Repo"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.github.com/en/desktop/contributing-and-collaborating-using-github-desktop/keeping-your-local-repository-in-sync-with-github/syncing-your-branch",
    target: "_blank"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 270,
    width: 270,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 270,
    width: 270,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 290,
      marginLeft: 487
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF8000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(255, 128, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "Push/Pull/Sync your code")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 487,
    y: 296,
    fill: "#FF8000",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Push/Pull/Sync your code"))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 609.04 368 L 575.37 368",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 570.12 368 L 577.12 364.5 L 575.37 368 L 577.12 371.5 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 359 368.5 L 246.47 368.94",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 241.22 368.96 L 248.2 365.43 L 246.47 368.94 L 248.23 372.43 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 651.5,
    y: 43.5,
    width: 69.23,
    height: 50,
    xlinkHref: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIgogICB4bWxuczppbmtzY2FwZT0iaHR0cDovL3d3dy5pbmtzY2FwZS5vcmcvbmFtZXNwYWNlcy9pbmtzY2FwZSIKICAgaWQ9ImFmY2MzNzgzLTczNzgtNDQ5Ny1iZjE1LTcyYzIwNjMzYmYyMSIKICAgd2lkdGg9IjE4IgogICBoZWlnaHQ9IjEzLjA3NTM2NyIKICAgdmlld0JveD0iMCAwIDE4IDEzLjA3NTM2NyIKICAgdmVyc2lvbj0iMS4xIgogICBzb2RpcG9kaTpkb2NuYW1lPSJDbG91ZF9TZXJ2aWNlc18oQ2xhc3NpYykuc3ZnIgogICBpbmtzY2FwZTp2ZXJzaW9uPSIwLjkyLjMgKDI0MDU1NDYsIDIwMTgtMDMtMTEpIj4KICA8c29kaXBvZGk6bmFtZWR2aWV3CiAgICAgcGFnZWNvbG9yPSIjZmZmZmZmIgogICAgIGJvcmRlcmNvbG9yPSIjNjY2NjY2IgogICAgIGJvcmRlcm9wYWNpdHk9IjEiCiAgICAgb2JqZWN0dG9sZXJhbmNlPSIxMCIKICAgICBncmlkdG9sZXJhbmNlPSIxMCIKICAgICBndWlkZXRvbGVyYW5jZT0iMTAiCiAgICAgaW5rc2NhcGU6cGFnZW9wYWNpdHk9IjAiCiAgICAgaW5rc2NhcGU6cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTp3aW5kb3ctd2lkdGg9IjE5MjAiCiAgICAgaW5rc2NhcGU6d2luZG93LWhlaWdodD0iMTAxNyIKICAgICBpZD0ibmFtZWR2aWV3Mzk0NCIKICAgICBzaG93Z3JpZD0iZmFsc2UiCiAgICAgZml0LW1hcmdpbi10b3A9IjAiCiAgICAgZml0LW1hcmdpbi1sZWZ0PSIwIgogICAgIGZpdC1tYXJnaW4tcmlnaHQ9IjAiCiAgICAgZml0LW1hcmdpbi1ib3R0b209IjAiCiAgICAgaW5rc2NhcGU6em9vbT0iNDguMTExMTExIgogICAgIGlua3NjYXBlOmN4PSI5IgogICAgIGlua3NjYXBlOmN5PSI1LjYyNDE0OTciCiAgICAgaW5rc2NhcGU6d2luZG93LXg9Ii04IgogICAgIGlua3NjYXBlOndpbmRvdy15PSItOCIKICAgICBpbmtzY2FwZTp3aW5kb3ctbWF4aW1pemVkPSIxIgogICAgIGlua3NjYXBlOmN1cnJlbnQtbGF5ZXI9ImFmY2MzNzgzLTczNzgtNDQ5Ny1iZjE1LTcyYzIwNjMzYmYyMSIgLz4KICA8ZGVmcwogICAgIGlkPSJkZWZzMzkyNyI+CiAgICA8bGluZWFyR3JhZGllbnQKICAgICAgIGlkPSJiODJkYTExOC05OTNkLTRjMzktODAzYy1jMzY2NzVkMzVlYmYiCiAgICAgICB4MT0iOC45ODk5OTk4IgogICAgICAgeTE9IjE2LjYxMDAwMSIKICAgICAgIHgyPSI4Ljk4OTk5OTgiCiAgICAgICB5Mj0iLTEuMjciCiAgICAgICBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wCiAgICAgICAgIG9mZnNldD0iMCIKICAgICAgICAgc3RvcC1jb2xvcj0iIzAwNzhkNCIKICAgICAgICAgaWQ9InN0b3AzOTE2IiAvPgogICAgICA8c3RvcAogICAgICAgICBvZmZzZXQ9IjAuMTYiCiAgICAgICAgIHN0b3AtY29sb3I9IiMxMzgwZGEiCiAgICAgICAgIGlkPSJzdG9wMzkxOCIgLz4KICAgICAgPHN0b3AKICAgICAgICAgb2Zmc2V0PSIwLjUzIgogICAgICAgICBzdG9wLWNvbG9yPSIjM2M5MWU1IgogICAgICAgICBpZD0ic3RvcDM5MjAiIC8+CiAgICAgIDxzdG9wCiAgICAgICAgIG9mZnNldD0iMC44MiIKICAgICAgICAgc3RvcC1jb2xvcj0iIzU1OWNlYyIKICAgICAgICAgaWQ9InN0b3AzOTIyIiAvPgogICAgICA8c3RvcAogICAgICAgICBvZmZzZXQ9IjEiCiAgICAgICAgIHN0b3AtY29sb3I9IiM1ZWEwZWYiCiAgICAgICAgIGlkPSJzdG9wMzkyNCIgLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDx0aXRsZQogICAgIGlkPSJ0aXRsZTM5MjkiPkljb24tY29tcHV0ZS0zMDwvdGl0bGU+CiAgPHBhdGgKICAgICBkPSJtIDE4LDkuMDAxMjE3NiBhIDQuMTEsNC4xMSAwIDAgMCAtMy41MSwtNCA1LjE0LDUuMTQgMCAwIDAgLTUuMjUsLTQuOTk5OTk5OTcgNS4yNiw1LjI2IDAgMCAwIC01LDMuNDY5OTk5OTcgNC44Nyw0Ljg3IDAgMCAwIC00LjI0LDQuOCA0Ljk0LDQuOTQgMCAwIDAgNS4wNyw0LjgwMDAwMDQgaCAwLjQ0IDguMjEgYSAxLjQ2LDEuNDYgMCAwIDAgMC4yMiwwIEEgNC4xMyw0LjEzIDAgMCAwIDE4LDkuMDAxMjE3NiBaIgogICAgIGlkPSJwYXRoMzkzMSIKICAgICBpbmtzY2FwZTpjb25uZWN0b3ItY3VydmF0dXJlPSIwIgogICAgIHN0eWxlPSJmaWxsOnVybCgjYjgyZGExMTgtOTkzZC00YzM5LTgwM2MtYzM2Njc1ZDM1ZWJmKSIgLz4KICA8Y2lyY2xlCiAgICAgY3g9IjUuMjM5OTk5OCIKICAgICBjeT0iOC4xMDEyMTczIgogICAgIHI9IjAuNzA5OTk5OTgiCiAgICAgaWQ9ImNpcmNsZTM5MzMiCiAgICAgc3R5bGU9ImZpbGw6I2UzZTNlMyIgLz4KICA8cGF0aAogICAgIGQ9Im0gNy43NCw4LjM3MTIxNzYgdiAtMC41NyBIIDcuNjYgbCAtMC42MSwtMC4yIC0wLjE2LC0wLjM5IDAuMzEsLTAuNjYgLTAuNCwtMC40IEggNi43MiBsIC0wLjU3LDAuMyAtMC4zOSwtMC4xNiAtMC4yNSwtMC42OSBIIDQuOTQgdiAwLjA4IGwgLTAuMiwwLjYxIC0wLjQyLDAuMTYgLTAuNjUsLTAuMzEgLTAuNCwwLjQgdiAwLjA4IGwgMC4yOSwwLjU3IC0wLjE2LDAuMzkgLTAuNywwLjI1IHYgMC42MiBoIDAuMDggbCAwLjYxLDAuMiAwLjE2LDAuMzkgLTAuMzEsMC42NiAwLjQsMC40MDAwMDA0IGggMC4wOCBsIDAuNTcsLTAuMjkwMDAwNCAwLjM5LDAuMTYgMC4yNSwwLjY5MDAwMDQgSCA1LjUgdiAtMC4wOCBsIDAuMiwtMC42MTAwMDA0IDAuMzksLTAuMTYgMC42NiwwLjMxMDAwMDQgMC40LC0wLjQwMDAwMDQgdiAtMC4wOCBsIC0wLjI5LC0wLjU3IDAuMTYsLTAuMzkgeiBtIC0yLjUsMC44MyBhIDEuMSwxLjEgMCAxIDEgMS4xLC0xLjEgMS4wOSwxLjA5IDAgMCAxIC0xLjEsMS4xIHoiCiAgICAgaWQ9InBhdGgzOTM1IgogICAgIGlua3NjYXBlOmNvbm5lY3Rvci1jdXJ2YXR1cmU9IjAiCiAgICAgc3R5bGU9ImZpbGw6I2ZmZmZmZiIgLz4KICA8Y2lyY2xlCiAgICAgY3g9IjEwIgogICAgIGN5PSI1LjA0MTIxNzgiCiAgICAgcj0iMC44Mzk5OTk5NyIKICAgICBpZD0iY2lyY2xlMzkzNyIKICAgICBzdHlsZT0iZmlsbDojZTNlM2UzIiAvPgogIDxwYXRoCiAgICAgZD0ibSAxMyw1LjM2MTIxNzYgdiAtMC42OCBoIC0wLjA5IGwgLTAuNzQsLTAuMjMgLTAuMTcsLTAuNTEgMC4zNywtMC44IC0wLjQ4LC0wLjQ4IEggMTEuOCBsIC0wLjY5LDAuMzUgLTAuNDYsLTAuMTkgLTAuMywtMC44MyBIIDkuNjQgdiAwLjEgbCAtMC4yNCwwLjczIC0wLjQ3LDAuMTkgLTAuNzgsLTAuMzcgLTAuNDgsMC40OCAwLjA1LDAuMDkgMC4yOCwwLjc0IC0wLjE2LDAuNSAtMC44NCwwLjI3IHYgMC43MyBoIDAuMSBsIDAuNzMsMC4yNCAwLjE3LDAuNDUgLTAuMzcsMC44IDAuNSwwLjUxIDAuMSwtMC4wNSAwLjY4LC0wLjM1IDAuNDcsMC4xOSAwLjMsMC44MyBoIDAuNjggdiAtMC4xIGwgMC4yNCwtMC43MyAwLjQ3LC0wLjE5IDAuNzksMC4zNyAwLjQ4LC0wLjQ4IC0wLjA1LC0wLjA5IC0wLjI5LC0wLjcyIDAuMTksLTAuNDcgeiBtIC0zLDEgYSAxLjMyLDEuMzIgMCAxIDEgMS4zMiwtMS4zMiAxLjMxLDEuMzEgMCAwIDEgLTEuMzIsMS4zMiB6IgogICAgIGlkPSJwYXRoMzkzOSIKICAgICBpbmtzY2FwZTpjb25uZWN0b3ItY3VydmF0dXJlPSIwIgogICAgIHN0eWxlPSJmaWxsOiNmZmZmZmYiIC8+CiAgPG1ldGFkYXRhCiAgICAgaWQ9Im1ldGFkYXRhMzk0MSI+CiAgICA8cmRmOlJERj4KICAgICAgPHJkZjpsaT5wdWJsaWM6dHJ1ZTwvcmRmOmxpPgogICAgICA8cmRmOmxpPnNkazpNc1BvcnRhbEZ4LkJhc2UuSW1hZ2VzLlBvbHljaHJvbWF0aWMuQ2xvdWRTZXJ2aWNlKCk8L3JkZjpsaT4KICAgICAgPHJkZjpsaT5jYXRlZ29yeTogQ29tcHV0ZTwvcmRmOmxpPgogICAgICA8Y2M6V29yawogICAgICAgICByZGY6YWJvdXQ9IiI+CiAgICAgICAgPGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+CiAgICAgICAgPGRjOnR5cGUKICAgICAgICAgICByZGY6cmVzb3VyY2U9Imh0dHA6Ly9wdXJsLm9yZy9kYy9kY21pdHlwZS9TdGlsbEltYWdlIiAvPgogICAgICAgIDxkYzp0aXRsZT5JY29uLWNvbXB1dGUtMzA8L2RjOnRpdGxlPgogICAgICA8L2NjOldvcms+CiAgICA8L3JkZjpSREY+CiAgPC9tZXRhZGF0YT4KPC9zdmc+Cg=="
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 154 395 L 154.79 418.64",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 154.96 423.88 L 151.23 417 L 154.79 418.64 L 158.23 416.77 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 305 480 L 351.88 480",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 360.88 480 L 351.88 484.5 L 351.88 475.5 Z",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 470,
      marginLeft: 334
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Yes")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 334,
    y: 473,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Yes")))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 572 480.04 L 597 480.04 L 597 484.04 L 615.63 484.02",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 620.88 484.02 L 613.89 487.52 L 615.63 484.02 L 613.88 480.52 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/get-started/pipelines-get-started?view=azure-devops",
    target: "_blank"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 448,
    width: 210,
    height: 64,
    rx: 9.6,
    ry: 9.6,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 480,
      marginLeft: 363
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Run the Azure Pipeline,", _br10 || (_br10 = /*#__PURE__*/React.createElement("br", null)), "build a new ", _b3 || (_b3 = /*#__PURE__*/React.createElement("b", null, "Release")), " (auto). Create a ", _b4 || (_b4 = /*#__PURE__*/React.createElement("b", null, "artifact")), " to publish.")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 467,
    y: 484,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Run the Azure Pipeline,..."))))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 620.99 500 L 578.37 500",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 573.12 500 L 580.12 496.5 L 578.37 500 L 580.12 503.5 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 362 501 L 265.47 501.01",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 260.22 501.01 L 267.22 497.51 L 265.47 501.01 L 267.22 504.51 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://portal.azure.com",
    target: "_blank"
  }, _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 621.5,
    y: 443.5,
    width: 78,
    height: 78,
    xlinkHref: "data:image/svg+xml;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 529,
      marginLeft: 661
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Azure", _br11 || (_br11 = /*#__PURE__*/React.createElement("br", null)), "Devops")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 661,
    y: 541,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Azure..."))))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 161,
    width: 180,
    height: 46,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 161,
    width: 180,
    height: 46,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 178,
      height: 1,
      paddingTop: 184,
      marginLeft: 552
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontStyle: "italic",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "- Could use ", _br12 || (_br12 = /*#__PURE__*/React.createElement("br", null)), _u || (_u = /*#__PURE__*/React.createElement("u", null, /*#__PURE__*/React.createElement("a", {
    href: "https://github.com/features/actions"
  }, "Github\xA0Actions"))), " and ", _u2 || (_u2 = /*#__PURE__*/React.createElement("u", null, /*#__PURE__*/React.createElement("a", {
    href: "https://docs.github.com/en/actions/using-workflows/workflow-syntax-for-github-actions"
  }, "Workflows"))), "\xA0 for CI/CD automation")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 730,
    y: 188,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "end",
    fontStyle: "italic"
  }, "- Could use...")))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://azure.microsoft.com/en-us/services/app-service/",
    target: "_blank"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 164,
    width: 191,
    height: 41,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 164,
    width: 191,
    height: 41,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 189,
      height: 1,
      paddingTop: 185,
      marginLeft: 358
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontStyle: "italic",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "- Could use ", _br13 || (_br13 = /*#__PURE__*/React.createElement("br", null)), _u3 || (_u3 = /*#__PURE__*/React.createElement("u", null, "Azure App Service")), " and automation to publish your\xA0code (Win/Linux)")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 547,
    y: 188,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "end",
    fontStyle: "italic"
  }, "- Could use..."))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/release/deployment-groups/?view=azure-devops",
    target: "_blank"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 575 L 305 630 L 155 685 L 5 630 Z",
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 290,
      height: 1,
      paddingTop: 628,
      marginLeft: 10
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, _b5 || (_b5 = /*#__PURE__*/React.createElement("b", null, "Automatically", /*#__PURE__*/React.createElement("br", null), "publish the new code (artifact)", /*#__PURE__*/React.createElement("br", null), "t")), "o a defined Deployment Group Target", _br14 || (_br14 = /*#__PURE__*/React.createElement("br", null)), "defined in Azure Devops")))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 632,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Automatically..."))))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 535 L 155 568.63",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 573.88 L 151.5 566.88 L 155 568.63 L 158.5 566.88 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 572 631.48 L 597 631.48 L 597 634.04 L 615.63 634.02",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 620.88 634.02 L 613.89 637.52 L 615.63 634.02 L 613.88 630.52 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 598,
    width: 210,
    height: 67,
    rx: 10.05,
    ry: 10.05,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 208,
      height: 1,
      paddingTop: 632,
      marginLeft: 363
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "The in-house server behind our ", _b6 || (_b6 = /*#__PURE__*/React.createElement("b", null, "firewall")), ", gets a copy of the new application pulled down into is ", _br15 || (_br15 = /*#__PURE__*/React.createElement("br", null)), _b7 || (_b7 = /*#__PURE__*/React.createElement("b", null, "IIS")), " Web Server")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 467,
    y: 635,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "The in-house server behind our fire...")))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 620.99 650 L 578.37 650",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 573.12 650 L 580.12 646.5 L 578.37 650 L 580.12 653.5 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 362 651 L 265.47 651.01",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 260.22 651.01 L 267.22 647.51 L 265.47 651.01 L 267.22 654.51 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 542,
    width: 122,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 542,
    width: 122,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 120,
      height: 1,
      paddingTop: 557,
      marginLeft: 173
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Build was successful", _br16 || (_br16 = /*#__PURE__*/React.createElement("br", null)), "We have a new artifact")))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 173,
    y: 560,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px"
  }, "Build was successful...")))), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    x: 627.03,
    y: 597.5,
    width: 75.47,
    height: 70,
    xlinkHref: "data:image/svg+xml;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 675,
      marginLeft: 665
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Use Azure ", _b8 || (_b8 = /*#__PURE__*/React.createElement("b", null, "Agents")), " running ", _br17 || (_br17 = /*#__PURE__*/React.createElement("br", null)), "on\xA0our local in-house ", _br18 || (_br18 = /*#__PURE__*/React.createElement("br", null)), "server,\xA0to do this work")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 687,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Use Azure Ag...")))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 745,
    width: 297.5,
    height: 70,
    rx: 10.5,
    ry: 10.5,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 296,
      height: 1,
      paddingTop: 780,
      marginLeft: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Users can now access the newly updated version", _br19 || (_br19 = /*#__PURE__*/React.createElement("br", null)), "of the application that was published to the ", _b9 || (_b9 = /*#__PURE__*/React.createElement("b", null, "in-house")), _b10 || (_b10 = /*#__PURE__*/React.createElement("b", null, "server")))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 153,
    y: 784,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Users can now access the newly updated version...")))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 685 L 155 739.63",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 744.88 L 151.5 737.88 L 155 739.63 L 158.5 737.88 Z",
    fill: "#595959",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/artifacts/build-artifacts?view=azure-devops&tabs=classic",
    target: "_blank"
  }, _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    x: 447.5,
    y: 674.49,
    width: 39.75,
    height: 36.83,
    xlinkHref: "data:image/svg+xml;base64,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"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 719,
      marginLeft: 468
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _b11 || (_b11 = /*#__PURE__*/React.createElement("b", null, "artifact")))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 731,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "artifa..."))))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 437.5 686 L 437.5 696 L 414.5 696 L 414.5 706.5 L 395.5 691 L 414.5 675.5 L 414.5 686 Z",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/get-started/key-pipelines-concepts?view=azure-devops",
    target: "_blank"
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 357.53,
    y: 408,
    width: 310,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 357.53,
    y: 408,
    width: 310,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 428,
      marginLeft: 513
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF8000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(255, 128, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "Azure Pipeline/Artifact/Release")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 513,
    y: 434,
    fill: "#FF8000",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Azure Pipeline/Artifact/Release"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/agents/agents?view=azure-devops&tabs=browser",
    target: "_blank"
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 359.53,
    y: 558,
    width: 260,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 359.53,
    y: 558,
    width: 260,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 578,
      marginLeft: 490
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF8000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(255, 128, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "Azure Agents/Deployment")))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 584,
    fill: "#FF8000",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Azure Agents/Deployment"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "http://localhost",
    target: "_blank"
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 760,
    width: 260,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 760,
    width: 260,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 780,
      marginLeft: 489
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF8000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(255, 128, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      textDecoration: "underline",
      whiteSpace: "nowrap"
    }
  }, "Users access new version")))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 489,
    y: 786,
    fill: "#FF8000",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle",
    fontWeight: "bold",
    textDecoration: "underline"
  }, "Users access new version"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://code.visualstudio.com/docs/editor/github",
    target: "_blank"
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 351.53,
    y: 225.5,
    width: 289.47,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 351.53,
    y: 225.5,
    width: 289.47,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 246,
      marginLeft: 496
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF8000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(255, 128, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "nowrap"
    }
  }, "Developer(s) make changes")))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 496,
    y: 252,
    fill: "#FF8000",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "Developer(s) make changes"))))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 315 247 L 315 239.5 Q 315 232 323.94 236.47 L 336.06 242.53 Q 345 247 336.06 251.47 L 323.94 257.53 Q 315 262 315 254.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 315 247 L 315 239.5 Q 315 232 323.94 236.47 L 336.06 242.53 Q 345 247 336.06 251.47 L 323.94 257.53 Q 315 262 315 254.5 Z",
    fill: "url(#mx-gradient-ffffff-1-ff9933-1-s-0)",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 312 780 L 312 772.5 Q 312 765 320.94 769.47 L 333.06 775.53 Q 342 780 333.06 784.47 L 320.94 790.53 Q 312 795 312 787.5 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 312 780 L 312 772.5 Q 312 765 320.94 769.47 L 333.06 775.53 Q 342 780 333.06 784.47 L 320.94 790.53 Q 312 795 312 787.5 Z",
    fill: "url(#mx-gradient-ffffff-1-ff9933-1-s-0)",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 632.5,
    y: 755,
    width: 68.5,
    height: 61,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 632.5,
    y: 755,
    width: 68.5,
    height: 61,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 657.6 762.18 C 657.6 766.16 653.41 769.35 648.19 769.35 C 642.95 769.35 639.29 766.16 639.29 762.18 C 639.29 758.19 642.95 755 648.19 755 C 653.41 755 657.6 758.19 657.6 762.18 Z M 701 816 L 662.83 816 L 662.83 784.9 L 701 784.9 Z M 675.9 780.92 L 698.4 780.92 L 698.4 784.51 L 675.9 784.51 Z M 694.21 770.94 C 694.21 780.92 694.21 780.92 694.21 780.92 C 676.43 780.92 676.43 780.92 676.43 780.92 C 676.43 767.36 676.43 767.36 676.43 767.36 C 692.12 768.96 692.12 768.96 692.12 768.96 C 692.12 768.96 694.21 768.96 694.21 770.94 Z M 660.21 812.02 C 649.76 812.02 649.76 812.02 649.76 812.02 C 649.76 802.45 649.76 802.45 649.76 802.45 C 644.52 802.45 644.52 802.45 644.52 802.45 C 644.52 812.02 644.52 812.02 644.52 812.02 C 634.07 812.02 634.07 812.02 634.07 812.02 C 633.02 812.02 632.5 812.41 632.5 813.21 C 632.5 814.41 632.5 814.41 632.5 814.41 C 632.5 815.2 633.02 816 634.07 816 C 660.21 816 660.21 816 660.21 816 C 661.26 816 661.78 815.2 661.78 814.41 C 661.78 813.21 661.78 813.21 661.78 813.21 C 661.78 812.41 661.26 812.02 660.21 812.02 Z M 660.74 797.66 C 638.78 797.66 638.78 797.66 638.78 797.66 C 638.78 774.14 638.78 774.14 638.78 774.14 C 638.78 773.34 638.24 772.55 637.21 772.55 C 635.1 772.55 635.1 772.55 635.1 772.55 C 634.07 772.55 633.02 773.34 633.02 774.14 C 633.02 800.85 633.02 800.85 633.02 800.85 C 633.02 801.65 634.07 802.04 635.1 802.04 C 637.21 802.04 637.21 802.04 637.21 802.04 C 660.74 802.04 660.74 802.04 660.74 802.04 C 661.78 802.04 662.83 801.65 662.83 800.85 C 662.83 799.25 662.83 799.25 662.83 799.25 C 662.83 798.45 661.78 797.66 660.74 797.66 Z M 655.5 770.94 C 672.24 780.12 672.24 780.12 672.24 780.12 C 673.29 780.51 673.81 781.31 673.81 782.12 C 673.81 783.31 672.24 784.51 670.15 784.51 C 669.62 784.51 669.1 784.51 668.59 784.1 C 654.47 777.73 654.47 777.73 654.47 777.73 C 654.47 789.69 654.47 789.69 654.47 789.69 C 662.31 789.69 662.31 789.69 662.31 789.69 C 662.31 797.26 662.31 797.26 662.31 797.26 C 639.81 797.26 639.81 797.26 639.81 797.26 C 639.81 771.75 639.81 771.75 639.81 771.75 C 639.81 771.75 639.81 769.75 644.52 769.75 C 652.36 769.75 652.36 769.75 652.36 769.75 C 652.36 769.75 653.93 769.75 655.5 770.94 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 657.6 762.18 C 657.6 766.16 653.41 769.35 648.19 769.35 C 642.95 769.35 639.29 766.16 639.29 762.18 C 639.29 758.19 642.95 755 648.19 755 C 653.41 755 657.6 758.19 657.6 762.18 Z M 701 816 L 662.83 816 L 662.83 784.9 L 701 784.9 Z M 675.9 780.92 L 698.4 780.92 L 698.4 784.51 L 675.9 784.51 Z M 694.21 770.94 C 694.21 780.92 694.21 780.92 694.21 780.92 C 676.43 780.92 676.43 780.92 676.43 780.92 C 676.43 767.36 676.43 767.36 676.43 767.36 C 692.12 768.96 692.12 768.96 692.12 768.96 C 692.12 768.96 694.21 768.96 694.21 770.94 Z M 660.21 812.02 C 649.76 812.02 649.76 812.02 649.76 812.02 C 649.76 802.45 649.76 802.45 649.76 802.45 C 644.52 802.45 644.52 802.45 644.52 802.45 C 644.52 812.02 644.52 812.02 644.52 812.02 C 634.07 812.02 634.07 812.02 634.07 812.02 C 633.02 812.02 632.5 812.41 632.5 813.21 C 632.5 814.41 632.5 814.41 632.5 814.41 C 632.5 815.2 633.02 816 634.07 816 C 660.21 816 660.21 816 660.21 816 C 661.26 816 661.78 815.2 661.78 814.41 C 661.78 813.21 661.78 813.21 661.78 813.21 C 661.78 812.41 661.26 812.02 660.21 812.02 Z M 660.74 797.66 C 638.78 797.66 638.78 797.66 638.78 797.66 C 638.78 774.14 638.78 774.14 638.78 774.14 C 638.78 773.34 638.24 772.55 637.21 772.55 C 635.1 772.55 635.1 772.55 635.1 772.55 C 634.07 772.55 633.02 773.34 633.02 774.14 C 633.02 800.85 633.02 800.85 633.02 800.85 C 633.02 801.65 634.07 802.04 635.1 802.04 C 637.21 802.04 637.21 802.04 637.21 802.04 C 660.74 802.04 660.74 802.04 660.74 802.04 C 661.78 802.04 662.83 801.65 662.83 800.85 C 662.83 799.25 662.83 799.25 662.83 799.25 C 662.83 798.45 661.78 797.66 660.74 797.66 Z M 655.5 770.94 C 672.24 780.12 672.24 780.12 672.24 780.12 C 673.29 780.51 673.81 781.31 673.81 782.12 C 673.81 783.31 672.24 784.51 670.15 784.51 C 669.62 784.51 669.1 784.51 668.59 784.1 C 654.47 777.73 654.47 777.73 654.47 777.73 C 654.47 789.69 654.47 789.69 654.47 789.69 C 662.31 789.69 662.31 789.69 662.31 789.69 C 662.31 797.26 662.31 797.26 662.31 797.26 C 639.81 797.26 639.81 797.26 639.81 797.26 C 639.81 771.75 639.81 771.75 639.81 771.75 C 639.81 771.75 639.81 769.75 644.52 769.75 C 652.36 769.75 652.36 769.75 652.36 769.75 C 652.36 769.75 653.93 769.75 655.5 770.94 Z",
    fill: "#036897",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 690,
    width: 124,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 690,
    width: 124,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 122,
      height: 1,
      paddingTop: 710,
      marginLeft: 174
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Azure performs the", _br20 || (_br20 = /*#__PURE__*/React.createElement("br", null)), "deployment through a\xA0", _br21 || (_br21 = /*#__PURE__*/React.createElement("br", null)), "firewall")))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 713,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px"
  }, "Azure performs the...")))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 304 630 L 350.88 630",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 359.88 630 L 350.88 634.5 L 350.88 625.5 Z",
    fill: "none",
    stroke: "#595959",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 620,
      marginLeft: 333
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Yes")))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 333,
    y: 623,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Yes")))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://azure.microsoft.com/en-us/overview/what-is-azure/",
    target: "_blank"
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 34,
      height: 1,
      paddingTop: 15,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Azure", _br22 || (_br22 = /*#__PURE__*/React.createElement("br", null)))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Azure&#xa;"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/architecture/example-scenario/apps/devops-dotnet-webapp",
    target: "_blank"
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 0,
    width: 36,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 0,
    width: 36,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 34,
      height: 1,
      paddingTop: 15,
      marginLeft: 45
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "CI/CD", _br23 || (_br23 = /*#__PURE__*/React.createElement("br", null)))))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "CI/CD&#xa;"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/architecture/solution-ideas/articles/devsecops-in-github",
    target: "_blank"
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 0,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 15,
      marginLeft: 89
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "DevSecOps", _br24 || (_br24 = /*#__PURE__*/React.createElement("br", null)))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 118,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "DevSecOps&#xa;"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/architecture/guide/",
    target: "_blank"
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 0,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 0,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 15,
      marginLeft: 164
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Architecture")))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 193,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Architecture"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/architecture/guide/",
    target: "_blank"
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 0,
    width: 99,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 0,
    width: 99,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 97,
      height: 1,
      paddingTop: 15,
      marginLeft: 234
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Architecture Styles", _br25 || (_br25 = /*#__PURE__*/React.createElement("br", null)))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 283,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Architecture Style..."))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://www.github.com",
    target: "_blank"
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 0,
    width: 40,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 0,
    width: 40,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 15,
      marginLeft: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Github")))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Github"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/agents/agents?view=azure-devops&tabs=browser",
    target: "_blank"
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 0,
    width: 42,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 383,
    y: 0,
    width: 42,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 40,
      height: 1,
      paddingTop: 15,
      marginLeft: 384
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Agents")))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 404,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Agents"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.github.com/en/actions/learn-github-actions/understanding-github-actions",
    target: "_blank"
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 0,
    width: 52,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 435,
    y: 0,
    width: 52,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 15,
      marginLeft: 436
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Workflows")))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 461,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Workflows"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/get-started/what-is-azure-pipelines?view=azure-devops#:~:text=Azure%20Pipelines%20combines%20continuous%20integration,automating%20merging%20and%20testing%20code.&text=Automated%20tests%20execute%20as%20part%20of%20the%20CI%20process%20to%20ensure%20quality.",
    target: "_blank"
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 0,
    width: 83,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 0,
    width: 83,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 81,
      height: 1,
      paddingTop: 15,
      marginLeft: 499
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Azure Pipelines")))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Azure Pipelines"))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/devops/pipelines/artifacts/pipeline-artifacts?view=azure-devops&tabs=classic",
    target: "_blank"
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 0,
    width: 41,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 591,
    y: 0,
    width: 41,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 39,
      height: 1,
      paddingTop: 15,
      marginLeft: 592
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Artifacts")))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 612,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "Artifac..."))))), /*#__PURE__*/React.createElement("a", {
    xlinkHref: "https://docs.microsoft.com/en-us/azure/app-service/overview-hosting-plans",
    target: "_blank"
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 0,
    width: 90,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 0,
    width: 90,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 15,
      marginLeft: 642
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #000000; border-color: #000000; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 11,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      border: "1px solid rgb(0, 0, 0)",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "App Service Plan")))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 686,
    y: 18,
    fill: "#000000",
    fontFamily: "Helvetica",
    fontSize: "11px",
    textAnchor: "middle"
  }, "App Service Plan")))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCiCdFlowchart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ci-cd-flowchart.102ec819.svg";
export { ForwardRef as ReactComponent };